<footer class="e11-bg-skin-app-bg e11-border-t e11-border-skin-app-borders e11-p-4">
  <h2 class="e11-text-skin-dark">{{ 'Footer' | translate }}</h2>
</footer>
